export const pt_BR = {
  links: {
    home: "Página Inicial",
    mission: "Missão",
    services: "Serviços",
    contact: "Contato",
    privacy: "Política de Privacidade",
    paymentPlans: "Planos de Pagamento",
  },
  contact: {
    title: "Contato",
    findUs: "Ache-nos",
    btnWhatsapp: "btn_whatsapp_ptBR.png",
    Call: "Ligue 754.752.1888",
    SMS: "MSG 754.752.1888",
    WhatsappMsg: "WhatsApp 754.276.1746",
    AfterHours:
      "ATENÇÃO: FORA DO HORÁRIO DE ATENDIMENTO E NOS FINAIS DE SEMANA - Estamos disponíveis somente por mensagem de texto em:",
  },
  img: {
    img1: "1_ptBR2.jpg",
    img2: "2_ptBR2.jpg",
  },
  footer: {
    quickLinks: "Links",
    bookAppointment: "Marcar Consulta",
    footerDisclaimer: "Consulta obrigatória. As prescrições são emitidas a critério do profissional médico com base na necessidade clínica. Os resultados podem variar de pessoa para pessoa.",
  },
  altsImgs: {
    btnWhatsapp: "Inicar conversa no whatsapp",
    logoDiverse: "Diverse Care Now",
    slide1: "Slide 1",
    slide2: "Slide 2",
  },
  carousel: {
    previous: "Anterior",
    next: "Próximo",
  },
  modal: {
    title: "Marcar uma consulta",
    message: "Agende sua consulta médica hoje",
    close: "Fechar",
    bookNow: "Agendar Consulta",
  },
  weightLoss: {
    meta: {
      title: "Programa Médico de Emagrecimento | Planos Personalizados e com Supervisão Médica | Diverse Care Now",
    },
    header: {
      bookAppointment: "AGENDAR CONSULTA",
    },
    hero: {
      headline: "Emagrecimento com acompanhamento médico, consultas online e suporte clínico completo.",
      subtitle: "Nosso Programa Médico de Emagrecimento foi desenvolvido para fornecer suporte seguro e supervisionado por médicos para o controle de peso sustentável.",
      description: "Este programa médico de emagrecimento combina avaliação clínica, planejamento personalizado e orientação sobre saúde metabólica para ajudar os pacientes a alcançarem resultados a longo prazo.",
    },
    features: {
      flexibleTitle: "Controle de Peso Flexível.",
      flexibleDesc: "Nossa abordagem clínica foca na saúde metabólica para apoiar seus objetivos, adaptando-se ao seu estilo de vida e rotina.",
      emotionalTitle: "Apoio para Comer Emocional e Desafios Diários",
      emotionalDesc: "Receba acompanhamento online estruturado e orientação clínica para ajudar a gerenciar seus hábitos alimentares e manter a consistência.",
      licensedTitle: "Especialização médica comprovada.",
      licensedDesc: "Sem modismos. Apenas planos de tratamento personalizados com profissionais certificados e gestão especializada de prescrições.",
    },
    provider: {
      title: "Especialista em Telemedicina para Emagrecimento e Cuidados com a Longevidade",
      subtitle: "Ajudando pacientes a alcançar resultados duradouros por meio de telemedicina guiada por médicos e perda de peso médica.",
      bio1: "Como médico certificado em emagrecimento e longevidade, ajudei milhares de pessoas a recuperar o controle — não apenas sobre o peso, mas também sobre a energia, a mentalidade e a saúde.",
      bio2: "Por isso criei a Diverse Care Now: um programa de telemedicina focado em ciência, segurança e cuidados médicos contínuos, com planos de tratamento personalizados e suporte clínico constante. Utilizamos tratamentos metabólicos baseados em evidências, sob rigorosa supervisão médica, além de acompanhamento nutricional e monitoramento remoto — sem necessidade de consultas presenciais.",
      missionIntro: "Minha missão é simples:",
      missionText: "ajudar você a alcançar resultados reais por meio de suporte médico — não restrição, mas sim cuidados inteligentes, seguros e liderados por médicos.",
      bookConsultation: "Agende sua consulta.",
    },
    stats: {
      count: "9.876+",
      patientsSupported: "Pacientes apoiados",
      tagline: "Recupere sua confiança e brilhe!",
      description: "Cuidados acessíveis e baseados em evidências para sua jornada de bem-estar.",
      proceduresPerformed: "Procedimentos realizados",
      proceduresDesc: "Procedimento eficaz e acessível, com resultados duradouros.",
    },
    clinicalSupport: {
      title: "Suporte clínico abrangente para o bem-estar metabólico a longo prazo.",
      intro: "Suporte clínico baseado em evidências, com foco na saúde metabólica e em hábitos de vida equilibrados.",
      body1: "Programas avançados de controle de peso, guiados por médicos, têm como foco o apoio ao bem-estar metabólico e às metas de saúde a longo prazo.",
      body2: "Esses programas são projetados para apoiar rotinas saudáveis e bem-estar a longo prazo, abordando fatores relacionados à consciência do apetite, digestão e saúde metabólica em geral.",
      focusIntro: "As áreas de foco do programa incluem:",
      focus1: "Consciência do apetite e padrões alimentares",
      focus2: "Controle de porções e equilíbrio digestivo",
      focus3: "Progresso consistente apoiado por hábitos saudáveis",
      closing1: "Sob orientação profissional, os planos de cuidados abrangentes enfatizam o progresso sustentável e a consistência, sempre em combinação com hábitos saudáveis.",
      closing2: "Nossos programas clínicos priorizam a saúde metabólica sustentável por meio de orientação profissional.",
    },
    pricing: {
      title: "Suporte Clínico Abrangente para Controle de Peso — Planos de Assinatura Disponíveis",
      intro: "Atendimento personalizado e supervisão médica contínua, guiados por profissionais licenciados e focados na saúde e no equilíbrio a longo prazo.",
      body: "Nosso programa começa com uma avaliação clínica e continua com acompanhamento estruturado, projetado para apoiar o bem-estar e as metas de saúde a longo prazo. Os programas são orientados clinicamente e adaptados aos perfis de saúde individuais, fatores de estilo de vida e metas de bem-estar a longo prazo.",
      emphasis: "Consciência da saúde metabólica, equilíbrio energético e suporte clínico profissional para o bem-estar a longo prazo. Esta não é uma solução de curto prazo. É um modelo de cuidado supervisionado por médicos, focado no bem-estar a longo prazo.",
      basicTitle: "PLANO DE CUIDADOS BÁSICO – OPÇÕES DE ASSINATURA",
      premiumTitle: "PLANO DE SUPORTE PREMIUM – CUIDADO MENSAL",
      disclaimer: "A dosagem e os detalhes do medicamento são determinados após avaliação médica. Apenas para fins ilustrativos. Não é garantia de tratamento ou quantidade.",
      premiumDisclaimer: "O tipo e a dosagem do medicamento são determinados após consulta médica. Apenas para fins informativos.",
      contraceptiveNote: "Alguns tratamentos médicos podem exigir considerações adicionais relacionadas ao uso de contraceptivos. Siga sempre as orientações do seu profissional de saúde e as instruções do fabricante.",
      contactSupport: "Para dúvidas clínicas ou acompanhamento, entre em contato diretamente com a Diverse Care Now.",
    },
    careProcess: {
      step1Title: "Consulta Inicial e Avaliação",
      step1Bullet1: "Histórico de saúde abrangente e revisão metabólica",
      step1Bullet2: "Plano de cuidados personalizado alinhado com seus objetivos e perfil de saúde",
      step2Title: "Programa de Cuidados Clínicos",
      step2Bullet1: "Supervisão profissional e monitoramento clínico",
      step2Bullet2: "Orientação contínua do provedor como parte de um modelo de cuidado supervisionado",
      step3Title: "Coaching de Nutrição e Estilo de Vida",
      step3Bullet1: "Suporte à estrutura de refeições e consciência de porções",
      step3Bullet2: "Gerenciamento de estresse e coaching focado em comportamento",
      step4Title: "Check-ins e Suporte Contínuo",
      step4Bullet1: "Acompanhamentos regulares por mensagem ou vídeo",
      step4Bullet2: "Responsabilidade e continuidade do cuidado a longo prazo",
      attribution: "Nosso programa inclui uma consulta clínica e um programa de cuidados estruturado e supervisionado por médicos, guiado pela Dra. Laura Uchôa e sua equipe médica licenciada.",
    },
    nutrition: {
      label: "ORIENTAÇÃO NUTRICIONAL.",
      title: "A BASE DE UM PROGRAMA DE BEM-ESTAR ESTRUTURADO",
      subtitle: "Desenvolvido pela Dra. Laura Uchôa e sua equipe, este plano nutricional personalizado foi projetado para apoiar a consistência, o equilíbrio e o bem-estar a longo prazo como parte de uma abordagem de cuidado supervisionada por médicos.",
      body: "Na Diverse Care Now, a orientação nutricional é fornecida como suporte estruturado dentro de um programa de cuidados abrangente, alinhado com preferências individuais, rotinas e metas gerais de saúde.",
      focus1: "Estrutura de refeições e escolhas alimentares equilibradas",
      focus2: "Consciência de porções e rotinas alimentares diárias",
      focus3: "Orientação personalizada alinhada com metas de bem-estar e níveis de atividade",
      closing: "Não é uma dieta genérica. É um plano nutricional estruturado, projetado para apoiar hábitos sustentáveis e consistência a longo prazo dentro de um programa supervisionado por médicos.",
    },
    testimonials: {
      title: "EXPERIÊNCIAS DOS PACIENTES E JORNADAS COMPARTILHADAS",
      intro: "Nossos pacientes confiam na Diverse Care Now para cuidados personalizados e guiados por médicos. Leia sobre suas experiências pessoais com nosso atendimento clínico.",
      reviewCount: "791 avaliações verificadas do Google",
      reviewScope: "Abrange programas de controle de peso, estéticos e de bem-estar",
      ratingNote: "Cada avaliação reflete nosso compromisso contínuo com a qualidade médica, empatia e suporte real",
      disclaimer: "Os resultados podem variar de pessoa para pessoa. Os resultados clínicos dependem dos perfis de saúde individuais e da adesão ao programa",
      voicesTitle: "VOZES DOS PACIENTES. ORIENTAÇÃO CLÍNICA. JORNADAS DE BEM-ESTAR",
      voicesBody: "Na clínica, Laura Uchôa e sua equipe demonstram como cuidados personalizados e guiados por médicos apoiam o equilíbrio, a confiança e a saúde a longo prazo.",
      reviews: [
        { name: 'Samuel Carvalho', time: '5 meses atrás', text: 'Este lugar me proporcionou o melhor Botox. A equipe é incrivelmente profissional e acolhedora.' },
        { name: 'Antonio Pinto', time: '3 meses atrás', text: 'Simplesmente O MELHOR LUGAR PARA CUIDADOS MÉDICOS. Toda a equipe é muito atenciosa, desde a recepção até os médicos.' },
        { name: 'Flavio Braga', time: '6 meses atrás', text: 'Ótima primeira visita! Equipe simpática, Dra. Laura Uchôa é muito atenciosa e conhecedora de tudo.' },
        { name: 'Maria Santos', time: '2 meses atrás', text: 'Dra. Uchôa realmente se importa com seus pacientes. A abordagem personalizada mudou minha vida.' },
        { name: 'John Davis', time: '4 meses atrás', text: 'Melhor experiência de telemedicina que já tive. A equipe é solidária e a orientação nutricional é prática.' },
        { name: 'Ana Paula', time: '1 mês atrás', text: 'Eu era cética sobre programas virtuais de perda de peso, mas a Diverse Care Now superou todas as minhas expectativas.' },
        { name: 'Carlos Mendes', time: '3 meses atrás', text: 'Serviço profissional do início ao fim. A equipe médica realmente ouve e cria um plano que funciona.' },
        { name: 'Jennifer Lopez', time: '5 meses atrás', text: 'Experiência incrível com o programa de controle de peso. Perdi 11 kg em 3 meses com orientação médica adequada.' },
      ],
    },
    comprehensiveApproach: {
      title: "UMA ABORDAGEM CLÍNICA ABRANGENTE FOCADA NO SEU BEM-ESTAR",
      subtitle: "Cada plano começa com uma avaliação médica abrangente focada na saúde metabólica, equilíbrio geral e bem-estar a longo prazo.",
      body: "Na Diverse Care Now, o cuidado é guiado por profissionais licenciados e adaptado aos seus objetivos, estilo de vida e perfil de saúde atual. Nossos programas integram supervisão médica, orientação nutricional e planejamento de atividades — com suporte contínuo projetado para se adaptar à medida que suas necessidades de saúde evoluem.",
      focus1: "Suporte para bem-estar metabólico e equilíbrio clínico",
      focus2: "Consciência do apetite e padrões alimentares",
      focus3: "Equilíbrio energético e consistência diária",
      focus4: "Progresso sustentável a longo prazo apoiado por hábitos saudáveis",
      keyMessage: "Isso não é uma 'solução rápida'. É uma parceria médica construída em torno da sua saúde, do seu ritmo e do bem-estar a longo prazo.",
      hipaa: "Compatível com HIPAA",
      boardCertified: "Provedor Certificado",
      secure: "Envio Seguro e Confidencial",
    },
    clinicalOversight: {
      title: "SUPERVISÃO CLÍNICA PROFISSIONAL E CUIDADO CONTÍNUO",
      body: "Na Diverse Care Now, a supervisão clínica é parte fundamental do nosso modelo de cuidado, fornecendo orientação profissional estruturada ao longo da sua jornada de bem-estar. Os acompanhamentos são estruturados para ajudar os provedores a revisar o progresso, responder perguntas e garantir que o cuidado permaneça alinhado com as necessidades individuais de saúde. Esta abordagem enfatiza continuidade, supervisão profissional e comunicação clara ao longo de toda a experiência de cuidado. As consultas agendadas fazem parte de um programa clinicamente supervisionado dedicado a apoiar seus objetivos de saúde e bem-estar a longo prazo.",
      credentialsTitle: "CUIDADO CLÍNICO DEDICADO E SUPORTE PROFISSIONAL",
      credentialsSubtitle: "Nossa abordagem foca na saúde metabólica e no bem-estar a longo prazo",
      cred1: "Na Diverse Care Now, os programas são adaptados para apoiar a consistência e a orientação clínica profissional",
      cred2: "Sob a orientação da Dra. Laura Uchôa, nossa equipe fornece cuidados estruturados projetados para se alinhar com perfis de saúde individuais e práticas clínicas baseadas em evidências",
      cred3: "Liderada pela Dra. Laura Uchôa, nossa equipe fornece cuidados estruturados e individualizados, projetados para apoiar metas de saúde sustentáveis com orientação profissional contínua e comunicação clara",
      cred4: "Priorizamos protocolos baseados em evidências e suporte ao paciente, garantindo comunicação clara e supervisão profissional ao longo de toda a sua experiência de cuidado",
    },
    enrollment: {
      cta1: "Comece com uma consulta profissional e avaliação personalizada",
      programsTitle: "PROGRAMAS CLÍNICOS ABRANGENTES DE BEM-ESTAR",
      body: "Cada plano de cuidado começa com uma avaliação médica abrangente realizada por provedores licenciados. As opções de tratamento, frequência de acompanhamento e estrutura de cuidado são determinadas individualmente com base no seu perfil de saúde, objetivos e histórico médico. Todo o cuidado é supervisionado pela Dra. Laura Uchôa e sua equipe médica licenciada, com monitoramento contínuo para garantir segurança, consistência e suporte a longo prazo. Detalhes específicos do tratamento, recomendações e opções são discutidos apenas após uma consulta profissional.",
      cta2: "Comece com uma consulta médica para verificar se o cuidado é apropriado para você",
      consultHeadline: "Discuta se o cuidado médico é apropriado para seus objetivos de saúde",
    },
    fourPillars: {
      title: "Os 4 Pilares Médicos por Trás da Perda de Peso Duradoura",
      subtitle: "Uma abordagem completa que combina cuidados clínicos, hábitos saudáveis e supervisão médica contínua",
      medicationTitle: "MEDICAÇÃO",
      medicationBody: "Tratamentos supervisionados ajudam a regular o apetite, melhorar o metabolismo e apoiar o progresso constante. Quando monitorados por profissionais, continuam sendo uma das ferramentas mais seguras e eficazes para o peso a longo prazo.",
      medicationLink: "Explore nosso blog para saber como as terapias supervisionadas por médicos funcionam com segurança",
      behaviorTitle: "Mudanças Comportamentais",
      behaviorBody: "A verdadeira mudança começa com a consistência diária. Acompanhar refeições, melhorar a qualidade do sono e gerenciar o estresse influenciam como o corpo responde ao tratamento e aos resultados de saúde a longo prazo.",
      behaviorLink: "Explore nosso blog para descobrir como pequenos hábitos criam resultados duradouros",
      activityTitle: "Atividade Física",
      activityBody: "O movimento fortalece corpo e mente. Mesmo exercícios leves e regulares melhoram a energia, o humor e o metabolismo — apoiando progresso gradual e constante e melhor bem-estar geral.",
      activityLink: "Explore nosso blog para maneiras simples e seguras de se manter ativo todos os dias",
      nutritionTitle: "Terapia Nutricional",
      nutritionBody: "A nutrição equilibrada é um componente central do cuidado abrangente. Escolher alimentos ricos em nutrientes ajuda a controlar a fome, estabilizar o açúcar no sangue e manter energia e saúde a longo prazo.",
      nutritionLink: "Explore nosso blog para menus saudáveis e guias de nutrição baseados em evidências",
    },
    calculator: {
      title: "O Que Seu Peso Não Diz, Mas Seus Hábitos Sim",
      subtitle: "Seu peso é mais do que um número. Descubra como sua rotina diária, metabolismo e nível de atividade realmente moldam seu corpo, e o que isso significa para seu plano de cuidado personalizado.",
      sex: "Sexo",
      male: "Masculino",
      female: "Feminino",
      age: "Idade",
      years: "anos",
      weight: "Peso",
      lbs: "libras",
      heightFeet: "Altura em pés",
      ft: "pés",
      heightInches: "Altura em polegadas",
      in: "pol",
      healthGoal: "Objetivo de Saúde",
      maintainWeight: "Manter Peso",
      cut250: "Corte (-250 kcal)",
      cut500: "Corte Agressivo (-500 kcal)",
      bulkSlow: "Ganho Lento (+200 kcal)",
      bulkLean: "Ganho Magro (+350 kcal)",
      activityLevel: "Nível de Atividade",
      sedentary: "Sedentário",
      sedentaryDesc: "Pouco ou nenhum exercício físico (trabalho de escritório)",
      light: "Leve",
      lightDesc: "Exercícios leves de 1 a 3 dias por semana",
      moderate: "Moderado",
      moderateDesc: "Exercício moderado de 3 a 5 dias por semana",
      active: "Ativo",
      activeDesc: "Exercícios intensos de 6 a 7 dias por semana",
      veryActive: "Muito Ativo",
      veryActiveDesc: "Exercício físico intenso e trabalho físico",
      extraActive: "Extra Ativo",
      extraActiveDesc: "Treinamento de nível de atleta ou trabalho muito físico",
      advancedToggle: "Avançado: Estimar % de Gordura Corporal (Marinha dos EUA)",
      waist: "Cintura",
      waistHint: "Meça na altura do umbigo (relaxado)",
      neck: "Pescoço",
      neckHint: "Abaixo do pomo de Adão",
      hip: "Quadril",
      hipHint: "Ponto mais largo dos quadris",
      advancedNote: "Os campos de gordura corporal são opcionais. Se deixados em branco, a gordura corporal não será estimada",
      calculate: "Calcular resultados",
      reset: "Redefinir todos os campos",
      resultsHeader: "SEUS RESULTADOS:",
      bmr: "Taxa Metabólica Basal (TMB)",
      bmi: "Índice de Massa Corporal (IMC)",
      targetCalories: "Meta de ingestão calórica por dia",
      macroBalance: "Equilíbrio de Macronutrientes",
      fats: "Gorduras",
      protein: "Proteínas",
      carbs: "Carboidratos",
      bodyFat: "Gordura Corporal",
      fatMass: "Massa Gorda",
      leanMass: "Massa Magra",
      disclaimer: "Conteúdo educacional apenas. Não é aconselhamento médico",
      inches: "polegadas",
    },
    activityRecs: {
      title: "Pequenos Passos. Progresso Real. Resultados a longo prazo",
      subtitle: "Você não precisa treinar como um atleta, basta manter a consistência. Nossa equipe médica recomenda hábitos simples e sustentáveis que se adaptam ao seu estilo de vida e promovem resultados duradouros",
      rec1: "2 sessões semanais de treino de resistência ou de força",
      rec2: "5.000 a 10.000 passos diários — a forma mais simples de exercício cardiovascular",
      rec3: "150 a 300 minutos de atividade física moderada por semana",
      rec4: "75 a 150 minutos de atividade de alta intensidade, caso você goste de se desafiar",
      disclaimer: "É necessária uma consulta. As recomendações individuais podem variar",
    },
    faq: {
      label: "Perguntas e Respostas sobre Perda de Peso",
      intro: "Antes de iniciar o tratamento, é natural ter dúvidas. Aqui estão as perguntas mais frequentes dos pacientes e o que nossa equipe médica quer que você saiba",
      q1: "O que são terapias médicas supervisionadas para perda de peso?",
      a1: "São tratamentos aprovados pela FDA, originalmente desenvolvidos para diabetes tipo 2, agora amplamente prescritos para controle de peso médico seguro. Eles ajudam a controlar o apetite, equilibrar a insulina e melhorar a função metabólica.",
      q2: "Esses medicamentos são seguros?",
      a2: "São seguros quando prescritos por um profissional de saúde. Os efeitos colaterais podem incluir náusea ou alterações digestivas, que são gerenciados por meio de ajustes de dose e suporte médico.",
      q3: "Quanto peso posso perder?",
      a3: "Alguns notam melhorias precoces no apetite e na energia em semanas, enquanto mudanças visíveis de peso geralmente aparecem após 4 a 8 semanas de tratamento consistente.",
      q4: "Ainda preciso fazer dieta e exercícios?",
      a4: "Sim, mudanças no estilo de vida potencializam os resultados e ajudam a mantê-los. Nosso coaching é projetado para tornar isso prático.",
      q5: "Em quanto tempo verei os resultados?",
      a5: "Alguns notam melhorias precoces no apetite e na energia em semanas, enquanto mudanças visíveis de peso geralmente aparecem após 4 a 8 semanas de tratamento consistente.",
    },
    finalCta: {
      headline: "Se você busca uma maneira segura, supervisionada e personalizada de alcançar seus objetivos, e não uma solução rápida, mas um plano médico real que se encaixe na sua rotina diária,",
      headlineBold: "a equipe da Diverse Care Now está pronta para orientá-lo(a) no próximo passo.",
      tagline: "Não se trata apenas de peso. Trata-se da sua energia, do seu ritmo, da sua confiança.",
      body1: "Sob a orientação da equipe médica da Diverse Care Now,",
      body2: "cada plano começa com um propósito: ajudar você a se sentir no controle do seu corpo novamente, com segurança, ciência e apoio em cada etapa.",
      speakCta: "Fale com um profissional de saúde e descubra se a terapia médica para perda de peso é adequada para você.",
      legalDisclaimer: "Nosso site e anúncios promovem um programa de emagrecimento com acompanhamento médico. Não vendemos nem anunciamos medicamentos controlados. Todos os tratamentos são supervisionados por profissionais médicos licenciados, conforme exigido por lei.",
    },
    footer: {
      email: "patientcare{'@'}diversecarenow.com",
      phone1: "(754) 752-1888",
      phone2: "17542761746",
      bookAppointment: "Agende uma consulta",
      termsOfUse: "Termos de Uso",
      privacyPolicy: "Política de Privacidade",
      copyright: "Copyright © 2025",
      companyName: "DIVERSE CARE NOW",
      allRights: "Todos os direitos reservados.",
      footerDisclaimer: "Consulta obrigatória. As prescrições são emitidas a critério do profissional médico com base na necessidade clínica. Os resultados podem variar de pessoa para pessoa.",
    },
    bitAssist: {
      call: "Ligar",
      sms: "SMS",
      whatsapp: "Whatsapp",
    },
  },
};
